export const callEmailAPI = async (data) => {
  let result;
  try {
    const response = await fetch("/.netlify/functions/sendmail", {
      method: "POST",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      result = { isSubmitting: false, response };
    }
    result = { isSubmitting: false, response };
  } catch (e) {
    result = { isSubmitting: false, response: e };
  }
  return result;
};
